import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { COMPANY } from "@/data/site";
import { FOOTER } from "@/constants/testIds";

const cols = [
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Leadership", to: "/leadership" },
      { label: "Careers", to: "/careers" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Property Management", to: "/property-management" },
      { label: "Asset Management", to: "/asset-management" },
      { label: "Hospitality Management", to: "/hospitality-management" },
      { label: "Portfolio Transition", to: "/portfolio-transition" },
    ],
  },
  {
    title: "Platform",
    links: [
      { label: "All Services", to: "/services" },
      { label: "Asset Classes", to: "/asset-classes" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Use", to: "/terms" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid={FOOTER.section} className="relative bg-[#121A16] grain-dark text-white pt-20 pb-10 overflow-hidden">
    <div className="max-w-[1320px] mx-auto px-6 md:px-10 relative">
      <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
        <div className="lg:col-span-5">
          <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1 mb-6">
            <div className="flex items-center gap-2.5">
              <Leaf className="w-7 h-7 text-[#8FB8A2]" strokeWidth={1.6} />
              <span className="font-display text-2xl">{COMPANY.name}</span>
            </div>
            <a href={COMPANY.phoneHref} className="font-data text-sm text-[#8FB8A2]">Phone: {COMPANY.phone}</a>
          </div>
          <p className="font-display text-2xl md:text-3xl font-light leading-snug text-white/90 max-w-md">
            We maximize property value through operational excellence.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title} className="lg:col-span-2">
            <h4 className="overline text-[#8FB8A2] mb-5">{c.title}</h4>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link data-testid={FOOTER.link(l.to.slice(1) || "home")} to={l.to} className="text-sm text-white/60 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40 leading-relaxed">
        <p className="max-w-3xl">
          © {new Date().getFullYear()} {COMPANY.name}. All rights reserved. GreatLeaf Management is a real estate asset and
          property management firm. Information on this site is for general purposes only and does not constitute an offer,
          solicitation, or investment, legal, tax, or financial advice.
        </p>
        <span className="font-display italic text-white/50 whitespace-nowrap">Operational excellence, at institutional scale.</span>
      </div>
    </div>
  </footer>
);
